import type { Cache } from 'swr';

export function getByCacheKey<T>(cache: Cache<T>, key: string) {
  return cache.get(key)?.data;
}
